import React, { useContext, useState, useRef } from "react";
import "../../../assests/css/customer/Customerlogin.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import AppContext from "../../../context/AppContext";

const Signup = ({ onSwitchToLogin }) => {
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [remember, setRemember] = useState(false);
  const [errormessage, setErrorMessage] = useState("");
  const { baseUrl, regExpChecker, setIsLoggedIn, setAuthToken } = useContext(AppContext);
  const navigate = useNavigate();

  const [isSignUpLoading, setIsSignUpLoading] = useState(false);

  // ── Verification step state ──
  const [authView, setAuthView] = useState("signup"); // 'signup' | 'verify'
  const [verifyCode, setVerifyCode] = useState("");
  const [verifyMessage, setVerifyMessage] = useState("");
  const [verifyLoading, setVerifyLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const submittingRef = useRef(false);

  const customerSignUpForm = (event) => {
    const emailError = regExpChecker("email", email);
    if (emailError) { setErrorMessage(emailError); return; }

    const passwordError = regExpChecker("password", password);
    if (passwordError) { setErrorMessage(passwordError); return; }

    const firstnameError = regExpChecker("firstname", firstname);
    if (firstnameError) { setErrorMessage(firstnameError); return; }

    const lastnameError = regExpChecker("lastname", lastname);
    if (lastnameError) { setErrorMessage(lastnameError); return; }

    if (submittingRef.current) return;
    submittingRef.current = true;

    setErrorMessage("");
    setIsSignUpLoading(true);

    const formdata = new FormData();
    formdata.append("firstname", firstname);
    formdata.append("lastname",  lastname);
    formdata.append("email",     email);
    formdata.append("password",  password);

    axios.post(`${baseUrl}/customer/auth/signup`, formdata)
      .then((response) => {
        console.log(response);

        if (response.data.success) {
          if (remember) {
            localStorage.setItem("CustomerEmail", email);
          }
          // Account create ho gaya lekin verified nahi — verify-code screen dikhao
          setAuthView("verify");
        } else {
          setErrorMessage(response.data.message || "Signup failed. Please try again.");
        }
      })
      .catch((error) => {
        console.log(error);
        setErrorMessage(error.response?.data?.message || "Something went wrong!");
      })
      .finally(() => {
        setIsSignUpLoading(false);
        submittingRef.current = false;
      });
  };

  // ── Verify email code ──
  const submitVerifyCode = () => {
    if (!verifyCode.trim()) { setVerifyMessage("Enter the verification code"); return; }
    if (submittingRef.current) return;
    submittingRef.current = true;

    setVerifyMessage("");
    setVerifyLoading(true);

    axios.post(`${baseUrl}/customer/auth/verify-email`, {
      email: email,
      code:  verifyCode,
    })
      .then((res) => {
        if (res.data.success) {
          setAuthToken(res.data.token);
          setIsLoggedIn(true);

          Swal.fire({
            icon:              "success",
            title:             "Welcome!",
            text:              "Your email has been verified successfully.",
            timer:             2000,
            showConfirmButton: false
          }).then(() => {
            navigate("/");
          });
        } else {
          setVerifyMessage(res.data.message || "Invalid code");
        }
      })
      .catch((error) => {
        setVerifyMessage(error.response?.data?.message || "Something went wrong!");
      })
      .finally(() => {
        setVerifyLoading(false);
        submittingRef.current = false;
      });
  };

  // ── Resend code ──
  const resendCode = () => {
    setResendLoading(true);
    setVerifyMessage("");

    axios.post(`${baseUrl}/customer/auth/resend-code`, { email: email })
      .then((res) => {
        if (res.data.success) {
          Swal.fire({
            icon: "success",
            title: "Code sent",
            text: res.data.message,
            timer: 2000,
            showConfirmButton: false,
          });
        } else {
          setVerifyMessage(res.data.message || "Could not resend code");
        }
      })
      .catch(() => {
        setVerifyMessage("Something went wrong!");
      })
      .finally(() => {
        setResendLoading(false);
      });
  };

  return (
    <div className="CustomerLoginForm-auth-container CustomerLoginForm-register">

      {/* LEFT PANEL */}
      <div className="CustomerLoginForm-neon-panel">
        <h2>WELCOME!</h2>
      </div>

      {/* RIGHT PANEL */}
      <div className="CustomerLoginForm-form-panel">

        {authView === "signup" && (
          <>
            <h2>Register</h2>

            <input
              type="text"
              placeholder="Johnathan"
              value={firstname}
              onChange={(e) => {
                setFirstname(e.target.value);
                setErrorMessage(regExpChecker("firstname", e.target.value));
              }}
            />

            <input
              type="text"
              placeholder="Doe"
              value={lastname}
              onChange={(e) => {
                setLastname(e.target.value);
                setErrorMessage(regExpChecker("lastname", e.target.value));
              }}
            />

            <input
              type="email"
              placeholder="name@example.com"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setErrorMessage(regExpChecker("email", e.target.value));
              }}
            />

            <div className="CustomerLoginForm-password-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="••••••••"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setErrorMessage(regExpChecker("password", e.target.value));
                }}
              />
              <span
                className="CustomerLoginForm-eye-icon"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a18.5 18.5 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                    <line x1="1" y1="1" x2="23" y2="23"></line>
                  </svg>
                ) : (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                )}
              </span>
            </div>

            <label className="CustomerLoginForm-remember">
              <input
                type="checkbox"
                checked={remember}
                onChange={(e) => setRemember(e.target.checked)}
              />
              Remember Me
            </label>

            {errormessage && <p className="error-text">{errormessage}</p>}

            {isSignUpLoading ? (
              <div className="d-flex justify-content-center">
                <Spinner style={{ height: 50, width: 50 }} />
              </div>
            ) : (
              <button onClick={customerSignUpForm}>Signup</button>
            )}

            <p className="CustomerLoginForm-switch">
              Already have an account?
              <span onClick={onSwitchToLogin}> Login</span>
            </p>
          </>
        )}

        {authView === "verify" && (
          <>
            <h2>Verify Your Email</h2>
            <p style={{ opacity: 0.8 }}>
              Verification code sent to {email}
            </p>

            <input
              type="text"
              placeholder="6-digit code"
              maxLength={6}
              value={verifyCode}
              onChange={(e) => setVerifyCode(e.target.value.replace(/\D/g, ""))}
            />

            {verifyMessage && <p className="error-text">{verifyMessage}</p>}

            {verifyLoading ? (
              <div className="d-flex justify-content-center">
                <Spinner style={{ height: 50, width: 50 }} />
              </div>
            ) : (
              <button onClick={submitVerifyCode}>Verify & Continue</button>
            )}

            <p className="CustomerLoginForm-switch">
              Didn't get a code?{" "}
              {resendLoading ? (
                <Spinner style={{ height: 16, width: 16 }} />
              ) : (
                <span onClick={resendCode}>Resend</span>
              )}
            </p>
          </>
        )}

      </div>

    </div>
  );
};

export default Signup;